<div class="">
  <span class="top-left-title-bar">{{title}}</span>
  <button (click)="emitValue(false)" type="button" class="close mr-4 mt-3" aria-label="Close"
          style="outline: none !important;">
    <span aria-hidden="true">&times;</span>
  </button>
<!--  <span class="close-btn close" (click)="emitValue(false)"></span>-->
</div>
<div class="modal-body text-center mt-5 mb-4">
{{message}}
</div>
<div class="modal-footer row justify-content-end" style="border:none; margin-top:-20px">


  <button type="button" class="cancel-button" (click)="emitValue(false)" >
    {{falsyText}}
  </button>
  <button  class="add-btn" (click)="emitValue(true)">
    {{truthyText}}
  </button>
</div>
